const getTime = () => {
    var date = new Date();
    //获取小时
    var hour = date.getHours();
    hour = hour < 10 ? "0" + hour : hour;
    //获取分钟
    var minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    //获取秒
    var second = date.getSeconds();
    second = second < 10 ? "0" + second : second;

    return hour + ":" + minute + ":" + second;
}

const getDate = () => {
    var now = new Date();
    var year = now.getFullYear(); //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate(); //日
    return year + "年" + +month + "月" + day + "日";
}



export {getTime,getDate}